export default __webpack_public_path__ + "static/media/csv_example.f208762a.png";